import { forwardRef } from 'react'

import styles from './Skeleton.module.css'

export interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Width of the skeleton (CSS value or number for px) */
  width?: string | number
  /** Height of the skeleton (CSS value or number for px) */
  height?: string | number
  /** Border radius variant */
  variant?: 'text' | 'rectangular' | 'rounded' | 'circular'
  /** Animation type */
  animation?: 'shimmer' | 'pulse' | 'none'
}

export const Skeleton = forwardRef<HTMLDivElement, SkeletonProps>(
  (
    {
      width,
      height,
      variant = 'rectangular',
      animation = 'shimmer',
      className,
      style,
      ...props
    },
    ref
  ) => {
    const classNames = [
      styles.skeleton,
      styles[variant],
      animation !== 'none' && styles[animation],
      className,
    ]
      .filter(Boolean)
      .join(' ')

    const computedStyle: React.CSSProperties = {
      ...style,
      width: typeof width === 'number' ? `${width}px` : width,
      height: typeof height === 'number' ? `${height}px` : height,
    }

    return (
      <div
        ref={ref}
        className={classNames}
        style={computedStyle}
        aria-hidden="true"
        {...props}
      />
    )
  }
)

Skeleton.displayName = 'Skeleton'
